const state = {
    brands: [
        'brand1.png',
        'brand2.png',
        'brand3.png',
        'brand4.png',
        'brand5.png',
        'brand6.png',
        'brand7.png',
        'brand8.png',
        'brand9.png',
        'brand10.png',
    ]
}

export {state}